import { BackTop, Breadcrumb, Button, Col, Row, Tooltip, Typography } from 'antd';
import { CloseOutlined, CopyOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { OrderStatus } from '../../../../../Constants/Order';
import { Roles } from '../../../../../Constants/Profile';
import { convertToMscTime } from '../../../../../Utils/convertToMscTime';
import { useAppSelector } from '../../../../../Store/hooks';

interface OrderHeaderProps {
  title: string;
  orderNumber: string;
  orderStatus: OrderStatus;
  finalAgreementId?: number;
  createdAt: Date;
  showCancelOrderModal: () => void;
  orderId: number;
}

const OrderHeader = (props: OrderHeaderProps) => {
  const role = useAppSelector((state) => state.user.role);
  const { title, orderStatus, orderNumber, createdAt, showCancelOrderModal, finalAgreementId, orderId } = props;

  const isCancelAllowed =
    role === Roles.CUSTOMER &&
    orderStatus !== OrderStatus.CANCELLED_BY_CUSTOMER &&
    orderStatus !== OrderStatus.CANCELLED_BY_DELIVERY &&
    orderStatus !== OrderStatus.DONE &&
    !finalAgreementId;

  return (
    <Row justify="space-between" align="middle" gutter={[0, 16]} className="order__header">
      <Col>
        <BackTop />
        <Breadcrumb className="order__breadcrumb" separator=">">
          <Breadcrumb.Item href="/">Главная страница</Breadcrumb.Item>
          <Breadcrumb.Item href="/customer/orders">Заказы</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Typography.Text ellipsis>{title}</Typography.Text>
          </Breadcrumb.Item>
        </Breadcrumb>
      </Col>
      <Col>
        <Typography.Text className="order__info">Номер заказа:</Typography.Text>
        <Typography.Text className="order__info" strong>
          {orderNumber}
        </Typography.Text>
        <Tooltip className="order__header-icon" title="Номер заказа нужен для обращения в поддержку">
          <QuestionCircleOutlined />
        </Tooltip>
        <Typography.Text className="order__info">Создан:</Typography.Text>
        <Typography.Text className="order__info" strong>
          {`${convertToMscTime(createdAt)} мск`}
        </Typography.Text>
      </Col>
      <Col span={14}>
        <Typography.Title level={2} ellipsis={{ tooltip: false }}>
          {title}
        </Typography.Title>
      </Col>
      <Col span="200px">
        <Link to={`/customer/dublicate/${orderId}`}>
          <Button size="large" icon={<CopyOutlined />}>
            Дублировать заказ
          </Button>
        </Link>
      </Col>
      {isCancelAllowed && (
        <Col span="200px">
          <Button size="large" onClick={showCancelOrderModal} icon={<CloseOutlined />}>
            Отменить заказ
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default OrderHeader;
